// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"448ae3c2","239":"e39fb35b","455":"55372804"}[chunkId] + ".chunk.js";
};